<template>
  <div class="home">
    <list-page/>
  </div>
</template>

<script>
// @ is an alias to /src


import ListPage from "@/components/page/HomeView/content/list-page.vue";

export default {
  name: 'HomeView',
  components: {ListPage},
  mounted() {
    document.body.style.overflow = 'visible';

    document.title = "Космическая миссия \"Ноофен-2024\"";

    let meta = document.querySelector("meta[name='description']");
    if (meta) {
      meta.setAttribute('content', 'Возглавьте подготовку астронавтов к полету в космос и преодолейте астению на их пути к звездам');
    } else {
      meta = document.createElement('meta');
      meta.name = "description";
      meta.content = "Возглавьте подготовку астронавтов к полету в космос и преодолейте астению на их пути к звездам";
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
    window.scrollTo(0, 0);

  },

}
</script>

<style lang="scss" scoped>
</style>
